<template>
    <router-link v-bind="$attrs" :to="target" class="no-style-link">
        <slot></slot>
    </router-link>
</template>

<script>
    export default {
        name: 'FolderButtonRouterLink',
        props: {
            target: [String, Object],
        }
    };
</script>

<style scoped>
    .no-style-link {
        text-decoration: none;
    }

</style>
